import { initialPowerBiReportExportState, PowerBiReportExportState } from './reducers/powerbi-report-export.reducer';

export const reportingFeatureKey = 'reporting';

export interface ReportingState {
    export: PowerBiReportExportState;
}

export const getInitialReportingState = (): ReportingState => ({
    export: initialPowerBiReportExportState
});
